import { Usage } from 'shared/interfaces/Usage';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const usageBaseEndpoint = '/usage';

export const UsageService = {
  getUsage: async (): Promise<Usage> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${usageBaseEndpoint}`
    });

    return response.data;
  }
};
